// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainbody {
    background-image:
        linear-gradient(var(--bg-overlay), var(--bg-overlay)),
        url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 240px;
    /* No will-change — opacity on this element never changes, keeping it would
       permanently allocate a GPU layer for the full-viewport background image */
}

/* HighlightWrapper holds real flow height so siblings stack naturally */
.HighlightWrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
}

.particle-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: hidden;
    /* One shared GPU layer for all particles instead of one per particle */
    will-change: transform;
    contain: strict;
}

@keyframes particle-fly {
    0% {
        transform: translate(-50%, -50%) translate(0, 0) scale(0);
        opacity: 0;
    }
    15% {
        opacity: var(--opacity, 0.5);
        transform: translate(-50%, -50%) translate(calc(var(--tx) * 0.1), calc(var(--ty) * 0.1)) scale(1);
    }
    85% {
        opacity: var(--opacity, 0.5);
    }
    100% {
        transform: translate(-50%, -50%) translate(var(--tx), var(--ty)) scale(0.3);
        opacity: 0;
    }
}

.particle-dot {
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0, 224, 182, 0.9) 0%, rgba(255, 255, 255, 0.6) 60%, transparent 100%);
    width: 3px;
    height: 3px;
    animation: particle-fly var(--duration, 16s) var(--delay, 0s) ease-out infinite;
    /* No individual will-change — parent overlay provides the GPU layer */
}

.highlight-content {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.HighlightHeading {
    font-size: clamp(48px, 7vw, 92px);
    font-weight: 600;
    text-align: center;
    background: var(--hero-heading-gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    line-height: 1.05;
    letter-spacing: -2px;
    margin: 0;
    max-width: 900px;
    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s backwards;
}

.HighlightParagraph {
    color: var(--text-secondary);
    font-size: clamp(15px, 1.2vw, 18px);
    font-weight: 400;
    text-align: center;
    max-width: 680px;
    margin-top: 28px;
    line-height: 1.7;
    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.4s backwards;
}

.HighlightButtonSection {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 40px;
    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.6s backwards;
}

.HighlightTickerSection {
    overflow: hidden;
    margin-top: 50px;
    width: 100%;
    max-width: 100%;
    mask-image: linear-gradient(to right,
            transparent 0%,
            black 5%,
            black 95%,
            transparent 100%);
    -webkit-mask-image: linear-gradient(to right,
            transparent 0%,
            black 5%,
            black 95%,
            transparent 100%);
    animation: hero-fade-in 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.8s backwards;
}

@keyframes hero-fade-up {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes hero-fade-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.ticker-track {
    display: flex;
    gap: 16px;
    animation: ticker-scroll 40s linear infinite;
    width: max-content;
    will-change: transform;
}

@keyframes ticker-scroll {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

.ticker-item {
    background: var(--bg-ticker);
    border: 1px solid var(--border-ticker);
    padding: 12px 22px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--color-ticker);
    font-size: 15px;
    font-weight: 400;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    transition: background 0.3s ease, border-color 0.3s ease;
}

.ticker-item:hover {
    background: var(--bg-ticker-hover);
    border-color: var(--border-ticker-hover);
}

.ticker-check {
    color: #00e0b6;
    display: flex;
    align-items: center;
}

@media (max-width: 768px) {
    .mainbody {
        padding-top: 160px;
        min-height: unset;
        position: relative;
    }

    .HighlightWrapper {
        min-height: unset;
    }

    .HighlightButtonSection {
        flex-direction: column;
        gap: 16px;
    }

    .HighlightTickerSection {
        margin-top: 30px;
    }

    .HighlightHeading {
        padding: 0 16px;
    }

    .HighlightParagraph {
        padding: 0 20px;
    }
}

@media (max-width: 480px) {
    .mainbody {
        padding-top: 120px;
        min-height: unset;
        position: relative;
    }

    .HighlightWrapper {
        min-height: unset;
    }

    .HighlightTickerSection {
        margin-top: 20px;
    }

    .ticker-item {
        padding: 10px 16px;
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BODY/Highlight/Highlight.css"],"names":[],"mappings":"AAAA;IACI;;+CAEiC;IACjC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB;gFAC4E;AAChF;;AAEA,wEAAwE;AACxE;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,gBAAgB;IAChB,uEAAuE;IACvE,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,yDAAyD;QACzD,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,iGAAiG;IACrG;IACA;QACI,4BAA4B;IAChC;IACA;QACI,2EAA2E;QAC3E,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,8GAA8G;IAC9G,UAAU;IACV,WAAW;IACX,+EAA+E;IAC/E,sEAAsE;AAC1E;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,0EAA0E;AAC9E;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0EAA0E;AAC9E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,0EAA0E;AAC9E;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;;;;6BAIyB;IACzB;;;;6BAIyB;IACzB,0EAA0E;AAC9E;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,4CAA4C;IAC5C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":[".mainbody {\n    background-image:\n        linear-gradient(var(--bg-overlay), var(--bg-overlay)),\n        url('../../../assets/bg.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100%;\n    min-height: 100vh;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: -1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding-top: 240px;\n    /* No will-change — opacity on this element never changes, keeping it would\n       permanently allocate a GPU layer for the full-viewport background image */\n}\n\n/* HighlightWrapper holds real flow height so siblings stack naturally */\n.HighlightWrapper {\n    position: relative;\n    width: 100%;\n    min-height: 100vh;\n}\n\n.particle-overlay {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    overflow: hidden;\n    /* One shared GPU layer for all particles instead of one per particle */\n    will-change: transform;\n    contain: strict;\n}\n\n@keyframes particle-fly {\n    0% {\n        transform: translate(-50%, -50%) translate(0, 0) scale(0);\n        opacity: 0;\n    }\n    15% {\n        opacity: var(--opacity, 0.5);\n        transform: translate(-50%, -50%) translate(calc(var(--tx) * 0.1), calc(var(--ty) * 0.1)) scale(1);\n    }\n    85% {\n        opacity: var(--opacity, 0.5);\n    }\n    100% {\n        transform: translate(-50%, -50%) translate(var(--tx), var(--ty)) scale(0.3);\n        opacity: 0;\n    }\n}\n\n.particle-dot {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(0, 224, 182, 0.9) 0%, rgba(255, 255, 255, 0.6) 60%, transparent 100%);\n    width: 3px;\n    height: 3px;\n    animation: particle-fly var(--duration, 16s) var(--delay, 0s) ease-out infinite;\n    /* No individual will-change — parent overlay provides the GPU layer */\n}\n\n.highlight-content {\n    position: relative;\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.HighlightHeading {\n    font-size: clamp(48px, 7vw, 92px);\n    font-weight: 600;\n    text-align: center;\n    background: var(--hero-heading-gradient);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n    line-height: 1.05;\n    letter-spacing: -2px;\n    margin: 0;\n    max-width: 900px;\n    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s backwards;\n}\n\n.HighlightParagraph {\n    color: var(--text-secondary);\n    font-size: clamp(15px, 1.2vw, 18px);\n    font-weight: 400;\n    text-align: center;\n    max-width: 680px;\n    margin-top: 28px;\n    line-height: 1.7;\n    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.4s backwards;\n}\n\n.HighlightButtonSection {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-top: 40px;\n    animation: hero-fade-up 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.6s backwards;\n}\n\n.HighlightTickerSection {\n    overflow: hidden;\n    margin-top: 50px;\n    width: 100%;\n    max-width: 100%;\n    mask-image: linear-gradient(to right,\n            transparent 0%,\n            black 5%,\n            black 95%,\n            transparent 100%);\n    -webkit-mask-image: linear-gradient(to right,\n            transparent 0%,\n            black 5%,\n            black 95%,\n            transparent 100%);\n    animation: hero-fade-in 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.8s backwards;\n}\n\n@keyframes hero-fade-up {\n    0% {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes hero-fade-in {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.ticker-track {\n    display: flex;\n    gap: 16px;\n    animation: ticker-scroll 40s linear infinite;\n    width: max-content;\n    will-change: transform;\n}\n\n@keyframes ticker-scroll {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(-50%);\n    }\n}\n\n.ticker-item {\n    background: var(--bg-ticker);\n    border: 1px solid var(--border-ticker);\n    padding: 12px 22px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: var(--color-ticker);\n    font-size: 15px;\n    font-weight: 400;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    transition: background 0.3s ease, border-color 0.3s ease;\n}\n\n.ticker-item:hover {\n    background: var(--bg-ticker-hover);\n    border-color: var(--border-ticker-hover);\n}\n\n.ticker-check {\n    color: #00e0b6;\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width: 768px) {\n    .mainbody {\n        padding-top: 160px;\n        min-height: unset;\n        position: relative;\n    }\n\n    .HighlightWrapper {\n        min-height: unset;\n    }\n\n    .HighlightButtonSection {\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .HighlightTickerSection {\n        margin-top: 30px;\n    }\n\n    .HighlightHeading {\n        padding: 0 16px;\n    }\n\n    .HighlightParagraph {\n        padding: 0 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .mainbody {\n        padding-top: 120px;\n        min-height: unset;\n        position: relative;\n    }\n\n    .HighlightWrapper {\n        min-height: unset;\n    }\n\n    .HighlightTickerSection {\n        margin-top: 20px;\n    }\n\n    .ticker-item {\n        padding: 10px 16px;\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
